import { Injectable, Injector } from '@angular/core';
import { VoucherLedger } from '../entities/voucher-ledger';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class VoucherLedgerService extends BaseCrudService<VoucherLedger> {

  public uri = '/api/voucherLedger/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance VoucherLedgerService');
  }

  buildSentence(entity?: VoucherLedger, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = "";
      /*
      let query = entity.row ? 'row'
        + QueryOperator.Contain + entity.row
        + QueryOperator.Split : QueryOperator.Empty;
      query = query.concat(
        entity.contractNumber ? 'contractNumber'
          + QueryOperator.Contain + entity.contractNumber
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.isCurrent ? 'isCurrent'
          + QueryOperator.Equal + entity.isCurrent
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.monthlyAmount ? 'monthlyAmount'
          + QueryOperator.Contain + entity.monthlyAmount
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.installment ? 'installment'
          + QueryOperator.Contain + entity.installment
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.totalAmount ? 'totalAmount'
          + QueryOperator.Contain + entity.totalAmount
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.processNumber ? 'processNumber'
          + QueryOperator.Contain + entity.processNumber
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.supportingDocumentNumber ? 'supportingDocumentNumber'
          + QueryOperator.Equal + entity.supportingDocumentNumber
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.issueContractDate ? 'issueContractDate'
          + QueryOperator.Equal + entity.issueContractDate
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.startContractDate ? 'startContractDate'
          + QueryOperator.Equal + entity.startContractDate
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.endContractDate ? 'endContractDate'
          + QueryOperator.Equal + entity.endContractDate
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.startDate ? 'startDate'
          + QueryOperator.Equal + entity.startDate
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.endDate ? 'endDate'
          + QueryOperator.Equal + entity.endDate
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.terminationDate ? 'terminationDate'
          + QueryOperator.Equal + entity.terminationDate.toISOString()
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.terminationDate === null ? 'terminationDate'
          + QueryOperator.IsNull
          + QueryOperator.Split : QueryOperator.Empty
      );
      if (entity.employee && entity.employee.id) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
        );
      }
      if (entity.employee && entity.employee.id==undefined) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${0}${QueryOperator.Split}`
        );
      }
      if (entity.employeeTtype) {
        query = query.concat(
          `employeeTtype.id${QueryOperator.Equal}${entity.employeeTtype.id}${QueryOperator.Split}`
        );
      }
      if (entity.employeeType) {
        query = query.concat(
          `employeeType.id${QueryOperator.Equal}${entity.employeeType.id}${QueryOperator.Split}`
        );
      } */
      /*
      if (entity.generalLedger.glType) {
        query = query.concat(
          `generalLedger.glType.code${QueryOperator.Equal}${entity.generalLedger.glType.code}${QueryOperator.Split}`
        );
      } 
     */
     if (entity.voucherMain) {
      query = query.concat(
        `voucherMain.id${QueryOperator.Equal}${entity.voucherMain.id}${QueryOperator.Split}`
      );
    } 
       this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
 

    return this.httpParams;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/voucher-ledger.service.ts